(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eu-gewaehrleistungslabel"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.euGewaehrleistungInit) return;
    window.euGewaehrleistungInit = true;

    // Zoomstufen relativ zur Groesse, in der das ganze Label ins Fenster passt
    var STUFEN = [1, 1.5, 2, 3, 4];
    // Horizon tauscht beim Variantenwechsel den Abschnitt per morph aus. Deshalb haengen alle
    // Ereignisse am document und der Zustand wird bei Bedarf neu am Dialog angelegt.
    var ziehen = null;

    function zustand(dialog) {
      if (dialog._eu) return dialog._eu;
      var z = (dialog._eu = {
        stufe: 0,
        buehne: dialog.querySelector('.eu-gewaehrleistung__buehne'),
        bild: dialog.querySelector('.eu-gewaehrleistung__zoombild'),
        wert: dialog.querySelector('[data-eu-zoom-wert]'),
        minus: dialog.querySelector('[data-eu-zoom="-1"]'),
        plus: dialog.querySelector('[data-eu-zoom="1"]'),
        gezogen: false,
      });

      // Mit gedrueckter Maustaste verschieben, wenn vergroessert
      z.buehne.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || z.stufe === 0) return;
        ziehen = { z: z, x: event.clientX, y: event.clientY, left: z.buehne.scrollLeft, top: z.buehne.scrollTop };
        z.gezogen = false;
      });

      // Strg + Mausrad bzw. Zwei-Finger-Zoom auf dem Touchpad
      z.buehne.addEventListener(
        'wheel',
        function (event) {
          if (!event.ctrlKey) return;
          event.preventDefault();
          zoom(dialog, z.stufe + (event.deltaY < 0 ? 1 : -1), event.clientX, event.clientY);
        },
        { passive: false }
      );

      z.bild.addEventListener('load', function () {
        zoom(dialog, z.stufe);
      });
      // Esc, Schliessen-Knopf und Klick daneben landen alle hier
      dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('eu-gewaehrleistung-offen');
      });
      return z;
    }

    function passendeBreite(z) {
      var stil = getComputedStyle(z.buehne);
      var breite = z.buehne.clientWidth - parseFloat(stil.paddingLeft) - parseFloat(stil.paddingRight);
      var hoehe = z.buehne.clientHeight - parseFloat(stil.paddingTop) - parseFloat(stil.paddingBottom);
      var verhaeltnis = z.bild.naturalWidth
        ? z.bild.naturalWidth / z.bild.naturalHeight
        : z.bild.getAttribute('width') / z.bild.getAttribute('height');
      return Math.max(120, Math.min(breite, hoehe * verhaeltnis));
    }

    function hoechsteStufe(z, passend) {
      // nicht weiter als 1,5-fache Originalaufloesung, mindestens aber 2-fach
      var grenze = Math.max((z.bild.naturalWidth || z.bild.getAttribute('width')) * 1.5, passend * 2);
      var max = 0;
      STUFEN.forEach(function (faktor, i) {
        if (passend * faktor <= grenze) max = i;
      });
      return max;
    }

    function zoom(dialog, stufe, clientX, clientY) {
      var z = zustand(dialog);
      var passend = passendeBreite(z);
      stufe = Math.max(0, Math.min(stufe, hoechsteStufe(z, passend)));

      var rahmen = z.buehne.getBoundingClientRect();
      var px = clientX == null ? rahmen.left + z.buehne.clientWidth / 2 : clientX;
      var py = clientY == null ? rahmen.top + z.buehne.clientHeight / 2 : clientY;
      var alt = z.bild.getBoundingClientRect();
      var relX = alt.width ? Math.min(1, Math.max(0, (px - alt.left) / alt.width)) : 0.5;
      var relY = alt.height ? Math.min(1, Math.max(0, (py - alt.top) / alt.height)) : 0.5;

      z.stufe = stufe;
      z.bild.style.width = Math.round(passend * STUFEN[stufe]) + 'px';

      // Punkt unter dem Mauszeiger bleibt an seiner Stelle
      var neu = z.bild.getBoundingClientRect();
      z.buehne.scrollLeft += neu.left + relX * neu.width - px;
      z.buehne.scrollTop += neu.top + relY * neu.height - py;

      z.buehne.classList.toggle('ist-gezoomt', stufe > 0);
      z.wert.textContent = Math.round(STUFEN[stufe] * 100) + ' %';
      z.minus.disabled = stufe === 0;
      z.plus.disabled = stufe === hoechsteStufe(z, passend);
    }

    function oeffnen(dialog) {
      var z = zustand(dialog);
      if (!z.bild.getAttribute('src')) z.bild.setAttribute('src', z.bild.getAttribute('data-src'));
      // Fenster startet bei 100 %: "−" schon vorher sperren, sonst bekommt er beim Oeffnen den Fokus
      // und verliert ihn gleich wieder (Tasten + − 0 wuerden dann nicht mehr greifen)
      z.minus.disabled = true;
      dialog.showModal();
      document.documentElement.classList.add('eu-gewaehrleistung-offen');
      z.buehne.scrollTop = 0;
      zoom(dialog, 0);
    }

    window.addEventListener('pointermove', function (event) {
      if (!ziehen) return;
      var dx = event.clientX - ziehen.x;
      var dy = event.clientY - ziehen.y;
      if (Math.abs(dx) + Math.abs(dy) > 4) {
        ziehen.z.gezogen = true;
        ziehen.z.buehne.classList.add('ist-ziehend');
      }
      ziehen.z.buehne.scrollLeft = ziehen.left - dx;
      ziehen.z.buehne.scrollTop = ziehen.top - dy;
    });
    window.addEventListener('pointerup', function () {
      if (!ziehen) return;
      ziehen.z.buehne.classList.remove('ist-ziehend');
      ziehen = null;
    });

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-eu-open]');
      if (opener) {
        // Dialog im selben Block suchen, nicht per id: Horizon kann denselben Block zweimal rendern
        var block = opener.closest('.eu-gewaehrleistung');
        var ziel = block && block.querySelector('dialog.eu-gewaehrleistung__lightbox');
        if (ziel && ziel.showModal) oeffnen(ziel);
        return;
      }
      var dialog = event.target.closest('dialog.eu-gewaehrleistung__lightbox');
      if (!dialog) return;
      var z = zustand(dialog);

      if (event.target.closest('[data-eu-close]')) {
        dialog.close();
      } else if (event.target.closest('[data-eu-zoom]')) {
        zoom(dialog, z.stufe + Number(event.target.closest('[data-eu-zoom]').getAttribute('data-eu-zoom')));
      } else if (event.target === z.bild) {
        if (z.gezogen) return (z.gezogen = false);
        zoom(dialog, z.stufe === 0 ? 2 : 0, event.clientX, event.clientY);
      } else if (event.target === z.buehne && z.stufe === 0) {
        // Klick neben das Label schliesst das Fenster
        dialog.close();
      }
    });

    document.addEventListener('keydown', function (event) {
      var dialog = document.querySelector('dialog.eu-gewaehrleistung__lightbox[open]');
      if (!dialog || event.ctrlKey || event.metaKey || event.altKey) return;
      var z = zustand(dialog);
      if (event.key === '+' || event.key === '=') zoom(dialog, z.stufe + 1);
      else if (event.key === '-') zoom(dialog, z.stufe - 1);
      else if (event.key === '0') zoom(dialog, 0);
      else return;
      event.preventDefault();
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('dialog.eu-gewaehrleistung__lightbox[open]').forEach(function (dialog) {
        zoom(dialog, zustand(dialog).stufe);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
